import $ from 'jquery';
import {createApp} from "vue";
import Verification from "./components/Verification.vue";

window.jQuery = $;
window.$ = $;

import('../../resources/main/js/vendor/modernizr-3.5.0.min.js');
import('../../resources/main/js/popper.min.js');
import('../../resources/main/js/bootstrap.min.js');
import('../../resources/main/js/jquery.sticky.js');
import('../../resources/main/js/jquery.slicknav.min.js');
import('../../resources/main/js/main.js');

const app = createApp({})


app.component('verification', Verification)
app.mount('#app')
